module.exports = __webpack_public_path__ + "media/sphere2.500KB.ca827b1f.mp4";